import React , {useState } from "react";
import { useSelector } from 'react-redux'
import { StudentEnrollCard } from "./StudentEnrollCard";
import 'moment/locale/es';
import { Button, Card, CardHeader, CardBody, FormGroup, Form, Row, Col, } from "reactstrap";
import AsyncSelect from 'react-select/async';


var courseApi = require ('../api');

var Utils = require ('Utils') ;


export const  CourseEnrollCard = ( { enroleStudent, unEnroleStudent, closeMe  } ) => {

  const [inputValue, setValue] = useState('');
  const [selectedValue, setSelectedValue] = useState(null);
  const [studentHistory, setStudentHistory] = useState(null);
  const [loadingHistoy, isLoadingHistory] = useState(false)

  const { course, token, currentCalendarID, isSaving } = useSelector(state => ({
    currentCalendarID: state.school.currentCalendarID,
    token: state.auth.session.jwt_token, 
    course: state.courses.course,
    isSaving: state.view.loadingModules.enrollingStudent 

   }))

    // handle input change event
    const handleInputChange = value => {
      setValue(value);
    };

   // handle selection
   const handleChange = value => {
    setSelectedValue(value);
    setStudentHistory([])
    isLoadingHistory(true);
    courseApi.getStudentCourseHistory ( token, value.persona_id ).then(res => { setStudentHistory( res ); isLoadingHistory(false); }) ;

    }
 

  const confirmEnroll = () => {
    if (selectedValue) { 
      enroleStudent (token, course.course_id, currentCalendarID, selectedValue.persona_id)
      closeMe(false)
    }
  }


    // load options using API call
    const loadOptions = (inputValue) => {
      if (inputValue.length >= 3 ) return courseApi.getUnroledStudents ( token, currentCalendarID, inputValue ).then(res => res );
    };

        return (
          
        <>
        <Card>
                <CardHeader>
                  <Row>
                    <Col className="pr-1" md="12">
                      <h5 className="title">Matriculación en {course.name} - {course.shift_name}</h5>
                    </Col>
                  </Row>
                </CardHeader>
                
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="pr-1" md="12">
                        <FormGroup>
                          <label>Alumno</label>
                          <AsyncSelect
                              cacheOptions
                              defaultOptions
                              value={selectedValue}
                              getOptionLabel={e => Utils.capitalize( e.last_name + ", " + e.name + " ( " + e.doc_type + ": " + e.doc_nbr + ")"  ) }
                              getOptionValue={e => e.persona_id}
                              loadOptions={loadOptions}
                              onInputChange={handleInputChange}
                              onChange={handleChange}
                              placeholder="Ingrese apellido ... "
                              noOptionsMessage={e => { return (<> No se encontro  <b>{inputValue}</b> </>) } }
                              loadingMessage={e => { if (inputValue.length >= 3 )
                                                        return "Buscando ... "
                                                        else return "ingrese al menos 3 letras del apellido para buscar"
                                                    }
                                              }
                            />
                            {selectedValue &&
                              <>
                                <br /><br />
                                <StudentEnrollCard
                                    student={selectedValue}
                                    studentHistory={studentHistory}
                                    loading={loadingHistoy}
                                />

                              <Button color="success" size="sm" disabled={isSaving}
                                onClick={() => confirmEnroll()}>
                              {isSaving?
                                <i className="nc-icon nc-refresh-69  fa-spin" />
                              :
                              <>
                                <span className="btn-label">
                                  <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                </span>
                                Confirmar matriculación
                              </>
                              }
                              </Button>
                            </>
                            }

                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              </>
          );
    }

    // 